module.exports = __webpack_public_path__ + "static/media/cyan-p.29621d05.svg";